import { Navigate } from 'react-router-dom';

import { AppRoutePath } from '../AppRoutePath';

export const ReplaceToHome = () => {
  return <Navigate to={AppRoutePath.Home} replace />;
};
